import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { Typography } from "@circleco/compass/components/Typography";
import { truncate } from "lodash";

import { classNames } from "@/react/helpers/twMergeWithCN";
import { useThemeContext } from "@/react/providers/Theme";

interface EntityItemProps {
  entity: any;
  handleClick: () => void;
  isSelected: boolean;
}

export const EntityItem = ({
  entity,
  handleClick,
  isSelected,
}: EntityItemProps) => {
  const {
    name,
    emoji,
    custom_emoji_url: customEmojiUrl,
    custom_emoji_dark_url: customEmojiDarkUrl,
  } = entity || {};
  const { currentAppearance } = useThemeContext();
  return (
    <Tooltip content={name} disabled={name?.length < 40}>
      <button
        type="button"
        className={classNames(
          "hover:bg-hover flex w-full cursor-pointer items-center truncate p-2 text-left text-primary rounded-md",
          { "bg-active": isSelected },
        )}
        onClick={handleClick}
      >
        {entity.type === "space" && (
          <EmojiRenderer
            className="!text-dark mr-2 flex !h-5 !w-auto items-center"
            emoji={emoji}
            customEmojiUrl={customEmojiUrl}
            customEmojiDarkUrl={customEmojiDarkUrl}
            appearance={currentAppearance}
          />
        )}
        <Typography variant="body-sm">
          {truncate(name, {
            length: 40,
          })}
        </Typography>
      </button>
    </Tooltip>
  );
};
